import React, { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import { useAppDispatch } from '../hooks';
import api from '../api';
import restaurantSlice from '../store/restaurantSlice';
import { useNavigate } from 'react-router-dom';
import appRoutes from '../utils/routes';
import Cookies from 'js-cookie';
import userSlice from '../store/userSlice';
import currentOrderSlice from '../store/orderSlice';
import supportedLocales, { dynamicActivate } from '../utils/locales';
import { isDevMode } from '../utils';

const StartScreen = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [isRestaurantReady, setIsRestaurantReady] = useState<boolean>(false);
    const [isMenuReady, setIsMenuReady] = useState<boolean>(false);
    const [isOrderReady, setIsOrderReady] = useState<boolean>(true);

    useEffect(() => {
        let domain: string | undefined;
        let subdomain: string | undefined;
        if (isDevMode()) {
            subdomain = undefined; // TODO: future stage subdomain goes here
            domain = undefined;
        } else {
            let host = window.location.host;

            if (host.split('.')[0] === "www") {
                host = window.location.host.slice(4);
            } 

            const hostElements = host.split('.');
            if (hostElements[1] === "klikmenu") {
                domain = ".klikmenu.be";
                subdomain = hostElements[0];
            } else {
                domain = host;
                subdomain = hostElements[0];
            }

        }

        const locale = Cookies.get('userLocale') || window.navigator.language.substring(0, 2);
        let localeforApi: string | undefined;
        if (Object.keys(supportedLocales).includes(locale)) {
            dispatch(userSlice.actions.setLocale(locale))
            localeforApi = locale
        }

        api.initApi(domain, subdomain, localeforApi).then(async () => {
            localeforApi && dynamicActivate(localeforApi)

            api.getMenu().then(data => {
                dispatch(restaurantSlice.actions.setMenuItems(data))
                setIsMenuReady(true)
            })
            api.getRestaurantInfo().then(data => {
                dispatch(restaurantSlice.actions.setRestaurantInfo(data))
                setIsRestaurantReady(true)
            })

            const token = Cookies.get('userData')
            try {
                token && api.getUserInfo().then(user => dispatch(userSlice.actions.setUserFromServer(user)))
                token && api.getCurrentOrder().then(order => {
                    dispatch(currentOrderSlice.actions.setOrderFromServer(order))
                    dispatch(userSlice.actions.setHasCurrentOrder(true))
                    setIsOrderReady(true)
                })
            } catch (err) {
                setIsOrderReady(true)
            }
        })
    }, [dispatch, setIsMenuReady, setIsRestaurantReady])

    useEffect(() => {
        isRestaurantReady && isMenuReady && isOrderReady && navigate(appRoutes.menu)
    })
    return <Loader />
}

export default StartScreen;